import React from 'react'
import { Container, Box, Typography } from '@mui/material'
import CodingVerification from '../components/mrd/MedicalCoding/CodingVerification'

export const CodingVerificationPage = () => {
  return (
    <Container maxWidth="xl">
      <CodingVerification />
    </Container>
  )
}

